import { render, staticRenderFns } from "./AccidentsTable.vue?vue&type=template&id=2bc650ec&"
import script from "./AccidentsTable.vue?vue&type=script&lang=js&"
export * from "./AccidentsTable.vue?vue&type=script&lang=js&"
import style0 from "./AccidentsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports